
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['authAllMap']),
  },
  permission (authCode) {
    return authCode && this.$store.state.Auth && this.$store.state.Auth.authAllMap[authCode] || false;
  },
};
